let routes = [
    {
      path: '/demande-declaration-formation',
      component: () => import('../views/DemandeDeclarationFormation.vue'),
      props: true
    },
    {
      path: '/demande-declaration-formation/:step',
      component: () => import('../views/DemandeDeclarationFormation.vue'),
      props: true
    }
  ]
  
  export default routes;